import { useContext } from 'react'
import QuickLinksContext from '../context/QuickLinksProvider';

const useQuickLinks = () => {
    return useContext(QuickLinksContext);
}

export default useQuickLinks